module.exports = __webpack_public_path__ + "static/avatarinvert-070f9323da6ca4f33adf3df686dc8c43.png";